import { render } from "./HueSlider.vue?vue&type=template&id=0f12d5be&scoped=true"
import script from "./HueSlider.vue?vue&type=script&lang=js"
export * from "./HueSlider.vue?vue&type=script&lang=js"

import "./HueSlider.vue?vue&type=style&index=0&id=0f12d5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f12d5be"]])

export default __exports__